function initVideoPlayers() {
	// if ( isTouch ) {
	// 	$('.video-html5:not(.autoplay)').find('video').trigger('pause');
	// 	$('.video-control').addClass('paused');
	// }

	$('.video-control').on('click', function() {
		$video = $(this).closest('.video-html5').find('video');

		if ( $(this).hasClass('paused') ) {
			$video.trigger('play');
			$(this).removeClass('paused');
		} else {
			$video.trigger('pause');
			$(this).addClass('paused');
		}
	});

	$('.video-mute').on('click', function() {

		$video = $(this).closest('.video-html5').find('video');

		if ( $video.prop('muted') ) {
			$video.prop('muted', false);
			$(this).addClass('unmuted');
		} else {
			$video.prop('muted', true);
			$(this).removeClass('unmuted');
		}
	});
}